import {z} from 'zod';
import paginatedSchema from "../common/paginatedSchema";

const seasonSchema = z.object({
    id: z.number(),
    year: z.number({
        invalid_type_error: 'Rok musí být číslo',
        required_error: 'Rok je povinný',
    })
        .int("Rok musí být celé číslo")
        .min(2000, "Rok musí být větší než 2000")
        .max(2100, "Rok musí být menší než 2100"),
    numberOfCountedRaces: z.number({
        invalid_type_error: 'Počet závodů musí být číslo',
        required_error: 'Počet závodů je povinný',
    })
        .int("Počet závodů musí být celé číslo")
        .min(1, "Počet závodů musí být větší než 0"),
});

const paginatedSeasons = paginatedSchema(seasonSchema);

type Season = z.infer<typeof seasonSchema>;
type PaginatedSeasons = z.infer<typeof paginatedSeasons>;

export {seasonSchema, paginatedSeasons, type Season, type PaginatedSeasons};